import type { Sparte } from '@/features/Global/types';

export class SessionError extends Error {
  private readonly sparte: Sparte;

  constructor(sparte: Sparte) {
    super();

    this.sparte = sparte;
  }

  public getSparte(): Sparte {
    return this.sparte;
  }
}
